﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederIofDto from '../Models/VeilederIofDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { satserReducer } from './Satser/Reducers';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<VeilederIofAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederIofDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederIofDto>,
    ): EpiContext<VeilederIofDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    satser: satserReducer,
});

export type VeilederIofAppState = EpiAppStateMedSteg<VeilederIofDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>;
};

export default function configureStore(): Store<VeilederIofAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
